import { render, staticRenderFns } from "./closeUpload.vue?vue&type=template&id=47b8eec4&scoped=true"
import script from "./closeUpload.vue?vue&type=script&lang=js"
export * from "./closeUpload.vue?vue&type=script&lang=js"
import style0 from "./closeUpload.vue?vue&type=style&index=0&id=47b8eec4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8eec4",
  null
  
)

export default component.exports